// Vendor imports
const { createSelector } = require('reselect')
// Client V2 common imports
const { defaultFeedSelectors: feedSelectors } = require('client-v2/common/containers/feed/selectors')
const tag = require('client-v2/common/utils/hyperscript')

const headerElement = createSelector(
  feedSelectors.getTitle,
  title => Boolean(title) && tag('div', title)
)

module.exports = {
  headerElement
}
